module.exports = __webpack_public_path__ + "7e92d1117c784b9b0ae0d1e7ffa47944.pdf";